import Cookies from "js-cookie";
import { REFRESH_TOKEN_COOKIE_NAME, REFRESH_TOKEN_EXPIRATION_MS } from "../config/auth";

export class AuthService {
  static setRefreshTokenCookie(refresh_token: string): void {
    Cookies.set(REFRESH_TOKEN_COOKIE_NAME, refresh_token, {
      expires: new Date(Date.now() + REFRESH_TOKEN_EXPIRATION_MS),
    });
  }

  static unsetRefreshTokenCookie(): void {
    Cookies.remove(REFRESH_TOKEN_COOKIE_NAME);
  }

  static getRefreshTokenCookie(): string | undefined {
    return Cookies.get(REFRESH_TOKEN_COOKIE_NAME);
  }
}
